import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./Reveal";

export const BrandDeskBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);

  return (
    <section ref={ref} className="relative bg-[#221b14] py-20 sm:py-28">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="relative overflow-hidden border border-amber-500/15">
          <motion.img
            style={{ y: imgY, scale: 1.18 }}
            src="/brand-desk.jpg"
            alt="B. Thornton Capital & Asset Group branded notepad and coffee mug on a desk"
            className="h-[420px] sm:h-[520px] w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-black via-black/70 to-transparent" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_50%,rgba(212,175,55,0.12),transparent_55%)]" />

          <div className="absolute inset-0 flex items-center justify-end">
            <div className="px-8 sm:px-14 max-w-xl text-right">
              <Reveal>
                <div className="flex justify-end">
                  <Overline>Where Strategy Begins</Overline>
                </div>
              </Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
                  Your Goals Take a{" "}
                  <span className="text-gold-foil">Seat at the Table.</span>
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-6 text-zinc-300 font-light leading-relaxed ml-auto">
                  Every plan starts with a conversation. We sit down with you,
                  map out a strategy, and put our name behind your success — one
                  disciplined decision at a time.
                </p>
              </Reveal>
              <Reveal delay={0.15}>
                <p className="mt-6 font-serif italic text-xl text-amber-400">
                  Building Wealth. Restoring Opportunity. Creating Legacy.
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
